import { put, takeEvery, call, all, select } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'

// import product services
import { getProducts, postProduct, putProduct, deleteProduct } from '../../services/products'

const getCurrentUser = state => state.user

export function* fetchProducts() {
  try {
    const user = yield select(getCurrentUser)
    const { data } = yield call(() => getProducts(user.token))
    yield put({
      type: actions.FETCH_PRODUCTS_SUCCESS,
      data,
    })
  } catch (error) {
    yield put({ type: actions.FETCH_PRODUCTS_ERROR, message: error.message })
  }
}

export function* setProduct(product) {
  try {
    const user = yield select(getCurrentUser)

    // ajusta los json
    product.payload.datetimedatajson = JSON.parse(product.payload.datetimedatajson)
    product.payload.sysdatajson = JSON.parse(product.payload.sysdatajson)
    product.payload.extradatajson = JSON.parse(product.payload.extradatajson)
    product.payload.operdatajson = JSON.parse(product.payload.operdatajson)
    product.payload.details = JSON.parse(product.payload.details)

    yield call(() => putProduct(user.token, product.payload))
    notification.success({
      message: 'Grabado exitoso',
      description: 'Se han guardado exitósamente los cambios',
    })
    yield put({
      type: actions.FETCH_PRODUCTS,
    })
  } catch (error) {
    yield put({ type: actions.PRODUCT_ERROR, message: error.message })
  }
}

export function* addProduct(product) {
  try {
    const user = yield select(getCurrentUser)

    // ajusta los json para que no se graben como string sino como objetos json en DB
    product.payload.extradatajson = JSON.parse(product.payload.extradatajson)
    product.payload.operdatajson = JSON.parse(product.payload.operdatajson)
    product.payload.details = JSON.parse(product.payload.details)

    yield call(() => postProduct(user.token, product.payload))
    notification.success({
      message: 'Grabado exitoso',
      description: 'Se ha agregado exitósamente el producto',
    })
    yield put({
      type: actions.FETCH_PRODUCTS,
    })
  } catch (error) {
    yield put({ type: actions.PRODUCT_ERROR, message: error.message })
  }
}

export function* delProduct(product) {
  try {
    const user = yield select(getCurrentUser)
    yield call(() => deleteProduct(user.token, product.payload.uid))
    notification.success({
      message: 'Borrado exitoso',
      description: 'Se ha eliminado exitósamente el producto',
    })
    yield put({
      type: actions.FETCH_PRODUCTS,
    })
  } catch (error) {
    yield put({ type: actions.PRODUCT_ERROR, message: error.message })
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_PRODUCTS, fetchProducts),
    takeEvery(actions.PRODUCT_SET, setProduct),
    takeEvery(actions.PRODUCT_ADD, addProduct),
    takeEvery(actions.PRODUCT_DEL, delProduct),
  ])
}
